/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">Connexion</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container ">
        <div class="text-center">
          <ion-spinner name="crescent" class="mc-st-loading-spinner"></ion-spinner>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">


</style>

<script>
  import {toast} from "../../Shared/Mixin/toast.mixin";
  import {isPlatform} from "@ionic/core";
  import {jwtDecode} from "jwt-decode"

  export default {
    name: 'eec-incentive',
    data () {
      return {
        loading: false,
        showMob: JSON.parse(process.env.VUE_APP_MOB),
      }
    },
    mixins: [toast],
    props : [],
    mounted() {
      if ( this.$store.state.userStore.user) {
        this.mobConnect();
      } else {
        this.login();
      }

    },
    methods: {
      mobConnect() {
        const data = {
          userId : this.$store.state.userStore.user.id,
          body : this.$route.name == 'eec-login' ? {
            "ssoProvider": this.$route.query.state,
            "ssoId": this.$route.query.code,
            "baseSiteUri": process.env.VUE_APP_DOMAIN.replace('m.' , '') + '/user/sso-mobile',
            "redirectUri" :  'login',
            "eec": 0
          } : {
            "ssoProvider": this.$route.query.state,
            "ssoId": this.$route.query.code,
            "baseSiteUri": process.env.VUE_APP_DOMAIN.replace('m.' , '') + '/user/sso-mobile',
            "eec": 1
          }
        }
        this.$store.dispatch('patch_user', data ).then((res) => {
          this.presentToast("Connexion réussie", "success");
          if (this.$route.name == 'eec-login') {
            this.getUser(res.id);
          } else {
            this.$router.replace({ path: '/carpools/eec-incentive' });
          }

        }).catch((error) => {
          console.log(error)
          this.presentToast(this.$t("Commons.error"), "danger");
        })
      },
      login() {
        let baseSiteUri = process.env.VUE_APP_DOMAIN.replace('m.' , '') + '/user/sso-mobile';
        if (this.showMob) {
          baseSiteUri = process.env.VUE_APP_DOMAIN.replace('m.' , '') + '/user/sso-mobile';
        }
        const data = {
          "ssoProvider": this.$route.query.state,
          "ssoId": this.$route.query.code,
          "baseSiteUri": baseSiteUri
        }
        this.$store.dispatch('loginSso', data ).then((res) => {
          this.getUser(jwtDecode(res.data.token).id);
        }).catch((error) => {
          console.log(error)
          this.presentToast(this.$t("Commons.error"), "danger");
        })
      },
      getUser(idUser) {
        const i18n = this.$i18n;
        // const t = $t("Login.logged");
        this.$store.dispatch('getUser', { idUser })
          .then(res => {
            //  this.presentToast(t, 'success');
            this.presentToast("Vous êtes connecté", 'success');
            this.email = '';
            this.password = '';

            const l = localStorage.getItem('language');
            i18n.locale = !!l ? l : 'fr';

            if (!! this.$store.getters.redirectionUrl) {
              this.$router.replace({name: this.$store.getters.redirectionUrl.name, params: this.$store.getters.redirectionUrl.params});
              this.$store.commit('redirectionUrl_reset');
            } else {
              this.$router.push({path : '/carpools/home'});
            }

            if(isPlatform(window.document.defaultView, "capacitor")) {
              PushNotifications.requestPermissions().then(result => {
                if (result.granted) {
                  // Register with Apple / Google to receive push via APNS/FCM
                  PushNotifications.register();
                } else {
                  // Show some error
                }
              });
            }

          })
          .catch(err => {
            this.presentToast("Une erreur est survenue", 'danger')
          })
      },
    }
  }
</script>
